/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindLeaveQueryResponse } from './FindLeaveQueryResponse';
import {
    FindLeaveQueryResponseFromJSON,
    FindLeaveQueryResponseFromJSONTyped,
    FindLeaveQueryResponseToJSON,
} from './FindLeaveQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListLeaveQueryResponse
 */
export interface ListLeaveQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListLeaveQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindLeaveQueryResponse>}
     * @memberof ListLeaveQueryResponse
     */
    data: Array<FindLeaveQueryResponse>;
}

/**
 * Check if a given object implements the ListLeaveQueryResponse interface.
 */
export function instanceOfListLeaveQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListLeaveQueryResponseFromJSON(json: any): ListLeaveQueryResponse {
    return ListLeaveQueryResponseFromJSONTyped(json, false);
}

export function ListLeaveQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLeaveQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindLeaveQueryResponseFromJSON)),
    };
}

export function ListLeaveQueryResponseToJSON(value?: ListLeaveQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindLeaveQueryResponseToJSON)),
    };
}

